import { render, staticRenderFns } from "./veStuEvaluationInfo.vue?vue&type=template&id=63da9bab&scoped=true"
import script from "./veStuEvaluationInfo.vue?vue&type=script&lang=js"
export * from "./veStuEvaluationInfo.vue?vue&type=script&lang=js"
import style0 from "./veStuEvaluationInfo.vue?vue&type=style&index=0&id=63da9bab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da9bab",
  null
  
)

export default component.exports